(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kensui-carousel-controller"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kensui-depth-carousel')) {
  class KensuiNativeCarousel extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.best = this.localName === 'kensui-best-carousel';
      this.bars = this.dataset.kind === 'bars';
      this.cssPrefix = this.best ? 'kh-best' : this.bars ? 'kh-bars' : 'kh-sw';
      this.cardSelector = '.' + this.cssPrefix + (this.best ? '__item' : '__card');
      this.grid = this.querySelector('.' + this.cssPrefix + (this.best ? '__stage' : '__grid'));
      this.cards = [...this.grid.querySelectorAll(this.cardSelector)];
      if (!this.cards.length) return;
      this.cards.forEach((card, i) => {
        card.dataset.carouselIndex = i;
        card.querySelectorAll('img').forEach(img => { img.draggable = false; });
      });
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.media = matchMedia(this.bars ? '(min-width:0px)' : '(max-width:768px)');
      this.reduce = matchMedia('(prefers-reduced-motion:reduce)');
      this.current = 0;
      this.grid.addEventListener('scroll', () => {
        if (!this.media.matches) return;
        this.queuePaint();
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settle(), 160);
      }, {signal, passive:true});
      this.grid.addEventListener('pointerdown', e => {
        if (!this.media.matches || e.pointerType !== 'mouse' || e.button !== 0) return;
        this.mouse = {id:e.pointerId, x:e.clientX, left:this.grid.scrollLeft, moved:false};
      }, {signal});
      this.grid.addEventListener('pointermove', e => {
        const mouse = this.mouse;
        if (!mouse || e.pointerId !== mouse.id) return;
        const delta = e.clientX - mouse.x;
        if (!mouse.moved && Math.abs(delta) < 5) return;
        if (!mouse.moved) this.grid.setPointerCapture(e.pointerId);
        mouse.moved = true;
        this.dataset.dragging = '';
        this.grid.scrollLeft = mouse.left - delta;
        e.preventDefault();
      }, {signal});
      const endMouse = e => {
        const mouse = this.mouse;
        if (!mouse || e.pointerId !== mouse.id) return;
        this.mouse = null;
        if (this.grid.hasPointerCapture(e.pointerId)) this.grid.releasePointerCapture(e.pointerId);
        delete this.dataset.dragging;
        if (mouse.moved) {
          this.suppressClickUntil = performance.now() + 450;
          this.goToPhysical(this.nearest(), false);
        }
      };
      window.addEventListener('pointerup', endMouse, {signal});
      this.grid.addEventListener('pointercancel', endMouse, {signal});
      this.grid.addEventListener('lostpointercapture', endMouse, {signal});
      this.grid.addEventListener('dragstart', e => { if (this.media.matches) e.preventDefault(); }, {signal});
      this.addEventListener('click', e => {
        if (!this.media.matches) return;
        const step = e.target.closest('[data-step]');
        const dot = e.target.closest('[data-slide]');
        if (step) this.goToPhysical(this.nearest() + Number(step.dataset.step));
        if (dot) this.goToLogical(Number(dot.dataset.slide));
        const card = e.target.closest(this.cardSelector);
        if (!card) return;
        if (e.detail !== 0 && performance.now() < (this.suppressClickUntil || 0)) { e.preventDefault(); return; }
        if (this.slides[this.nearest()] !== card) {
          e.preventDefault();
          this.goToPhysical(this.slides.indexOf(card));
        }
      }, {signal});
      this.addEventListener('keydown', e => {
        if (!this.media.matches || !['ArrowLeft','ArrowRight','Home','End'].includes(e.key)) return;
        e.preventDefault();
        const index = e.key === 'Home' ? 0 : e.key === 'End' ? this.cards.length - 1 : (this.current + (e.key === 'ArrowRight' ? 1 : -1) + this.cards.length) % this.cards.length;
        this.goToLogical(index);
        if (e.target.closest(this.cardSelector)) this.cards[index].focus({preventScroll:true});
      }, {signal});
      this.media.addEventListener('change', () => this.layout(), {signal});
      window.addEventListener('resize', () => {
        clearTimeout(this.resizeTimer);
        this.resizeTimer = setTimeout(() => this.goToPhysical(this.cloneCount + this.current, true), 80);
      }, {signal});
      this.dataset.ready = '';
      this.layout();
    }
    layout() {
      this.grid.querySelectorAll('.kh-carousel-slot').forEach(slot => slot.replaceWith(...slot.childNodes));
      this.grid.querySelectorAll('[data-carousel-clone]').forEach(card => card.remove());
      this.cloneCount = 0;
      this.toggleAttribute('data-native', this.media.matches);
      if (!this.media.matches) {
        this.cards.forEach(card => {
          card.removeAttribute('style');
          card.removeAttribute('tabindex');
          card.removeAttribute('aria-hidden');
          card.toggleAttribute('data-active', true);
        });
        this.slides = this.cards;
        return;
      }
      this.cloneCount = Math.min(2, this.cards.length - 1);
      const clone = card => {
        const copy = card.cloneNode(true);
        copy.dataset.carouselClone = '';
        copy.removeAttribute('id');
        copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        copy.setAttribute('aria-hidden', 'true');
        copy.tabIndex = -1;
        return copy;
      };
      const before = document.createDocumentFragment();
      if (this.cloneCount) this.cards.slice(-this.cloneCount).forEach(card => before.appendChild(clone(card)));
      this.grid.prepend(before);
      this.cards.slice(0, this.cloneCount).forEach(card => this.grid.appendChild(clone(card)));
      this.slides = [...this.grid.querySelectorAll(this.cardSelector)];
      this.slides.forEach(card => {
        const slot = document.createElement('div');
        slot.className = 'kh-carousel-slot';
        card.before(slot);
        slot.appendChild(card);
      });
      requestAnimationFrame(() => this.goToPhysical(this.cloneCount + this.current, true));
    }
    target(index) {
      const slot = this.slides[index].parentElement;
      return slot.offsetLeft + slot.offsetWidth / 2 - this.grid.clientWidth / 2;
    }
    nearest() {
      if (!this.slides?.length) return 0;
      let best = 0, distance = Infinity;
      this.slides.forEach((card, i) => {
        const d = Math.abs(this.target(i) - this.grid.scrollLeft);
        if (d < distance) { distance = d; best = i; }
      });
      return best;
    }
    goToLogical(index) {
      let candidates = this.slides.map((card, i) => Number(card.dataset.carouselIndex) === index ? i : -1).filter(i => i >= 0);
      candidates.sort((a,b) => Math.abs(this.target(a) - this.grid.scrollLeft) - Math.abs(this.target(b) - this.grid.scrollLeft));
      this.goToPhysical(candidates[0]);
    }
    goToPhysical(index, instant = false) {
      if (!this.media.matches || !this.slides?.length) return;
      index = Math.max(0, Math.min(this.slides.length - 1, index));
      this.grid.scrollTo({left:this.target(index), behavior:instant || this.reduce.matches ? 'instant' : 'smooth'});
      this.paint();
      clearTimeout(this.settleTimer);
      this.settleTimer = setTimeout(() => this.settle(), instant ? 30 : 180);
    }
    queuePaint() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.paint(); });
    }
    paint() {
      if (!this.media.matches || !this.slides?.length) return;
      const left = this.grid.scrollLeft;
      const positions = this.slides.map((card, i) => this.target(i));
      const nearest = positions.reduce((best, value, i) => Math.abs(value - left) < Math.abs(positions[best] - left) ? i : best, 0);
      this.current = Number(this.slides[nearest].dataset.carouselIndex);
      const stride = this.slides.length > 1 ? this.slides[1].parentElement.offsetLeft - this.slides[0].parentElement.offsetLeft : 1;
      this.slides.forEach((card, i) => {
        const distance = (positions[i] - left) / stride;
        const n = Math.abs(distance), active = i === nearest;
        card.style.setProperty('--depth', -Math.min(n,2) * 65 + 'px');
        card.style.setProperty('--turn', -Math.max(-1,Math.min(1,distance)) * 14 + 'deg');
        card.style.setProperty('--scale', Math.max(.6,1 - n * .18));
        card.style.setProperty('--opacity', Math.max(0,1 - n * .4));
        card.style.zIndex = String(100 - Math.round(n * 20));
        card.parentElement.style.zIndex = card.style.zIndex;
        card.style.pointerEvents = n > 2.25 ? 'none' : '';
        card.toggleAttribute('data-active', active);
        card.tabIndex = active ? 0 : -1;
        card.setAttribute('aria-hidden', String(!active));
      });
      this.dots.forEach((dot,i) => dot.setAttribute('aria-pressed', String(i === this.current)));
    }
    settle() {
      if (this.mouse || !this.media.matches) return;
      this.paint();
      const nearest = this.nearest();
      if (this.slides[nearest]?.hasAttribute('data-carousel-clone')) {
        this.grid.scrollTo({left:this.target(this.cloneCount + this.current),behavior:'instant'});
        this.paint();
      }
      const status = this.querySelector('[data-status], [data-carousel-status]');
      if (status) status.textContent = String(this.current + 1).padStart(2,'0') + ' / ' + String(this.cards.length).padStart(2,'0');
    }
    disconnectedCallback() {
      clearTimeout(this.settleTimer);
      clearTimeout(this.resizeTimer);
      cancelAnimationFrame(this.frame);
      this.grid?.querySelectorAll('.kh-carousel-slot').forEach(slot => slot.replaceWith(...slot.childNodes));
      this.grid?.querySelectorAll('[data-carousel-clone]').forEach(card => card.remove());
      this.controller?.abort();
      this.controller = null;
    }
  }
  customElements.define('kensui-depth-carousel', class extends KensuiNativeCarousel {});
  customElements.define('kensui-best-carousel', class extends KensuiNativeCarousel {});
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kensui-grip-launch"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kensui-grip-launch')) {
    customElements.define('kensui-grip-launch', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const {signal} = this.controller;
        const films = [...this.querySelectorAll('[data-kgl-film]')];
        const videos = films.map(film => film.querySelector('video'));
        const offers = [...this.querySelectorAll('[data-kgl-offer]')];
        const buttons = [...this.querySelectorAll('[data-kgl-finish]')];
        const playButton = this.querySelector('[data-kgl-play]');
        const label = this.querySelector('[data-kgl-label]');
        const icon = this.querySelector('[data-kgl-icon]');
        const error = this.querySelector('[data-kgl-error]');
        const reduced = matchMedia('(prefers-reduced-motion: reduce)');
        let current = Number(this.dataset.current ?? 2);
        let inView = false;
        let userPaused = false;
        let attempt = 0;
        videos.forEach(video => { video.controls = false; video.muted = true; });
        this.querySelector('[data-kgl-controls]').hidden = false;
        playButton.hidden = false;
        const sync = () => {
          const paused = videos[current].paused;
          label.textContent = paused ? label.dataset.play : label.dataset.pause;
          icon.textContent = paused ? '▶' : 'Ⅱ';
        };
        const pause = () => { attempt++; videos.forEach(video => video.pause()); sync(); };
        const play = async () => {
          const video = videos[current];
          const id = ++attempt;
          error.hidden = true;
          if (video.error) video.load();
          try { await video.play(); }
          catch (reason) {
            if (id !== attempt || reason.name === 'AbortError') return;
            if (reason.name !== 'NotAllowedError') error.hidden = false;
            sync();
          }
        };
        const automatic = () => {
          if (inView && !document.hidden && !reduced.matches && !navigator.connection?.saveData && !userPaused) play();
          else pause();
        };
        const choose = index => {
          pause();
          current = index;
          this.dataset.current = String(index);
          films.forEach((film, position) => { film.hidden = position !== index; });
          offers.forEach(offer => { offer.hidden = Number(offer.dataset.kglOffer) !== index; });
          buttons.forEach((button, position) => button.setAttribute('aria-pressed', String(position === index)));
          error.hidden = true;
          automatic();
        };
        buttons.forEach((button, index) => button.addEventListener('click', () => choose(index), {signal}));
        playButton.addEventListener('click', () => {
          userPaused = !videos[current].paused;
          if (userPaused) pause();
          else play();
        }, {signal});
        videos.forEach((video, index) => {
          video.addEventListener('play', sync, {signal});
          video.addEventListener('pause', sync, {signal});
          video.addEventListener('error', () => { if (current === index) error.hidden = false; }, {signal});
        });
        document.addEventListener('visibilitychange', automatic, {signal});
        reduced.addEventListener('change', automatic, {signal});
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            inView = entries[0].isIntersecting && entries[0].intersectionRatio >= .3;
            automatic();
          }, {threshold:[0,.3]});
          this.observer.observe(this.querySelector('.kgl-media'));
        }
        choose(current);
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.controller = null;
        this.observer?.disconnect();
        this.querySelectorAll('video').forEach(video => video.pause());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kensui-plate-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('kensui-plate-motion')) {
    customElements.define('kensui-plate-motion', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) { this.resumeConnections(); return; }
        this.initialized = true;
        const video = this.querySelector('video');
        const toggle = this.querySelector('[data-motion-toggle]');
        const label = this.querySelector('[data-motion-label]');
        const icon = this.querySelector('[data-motion-icon]');
        const error = this.querySelector('[data-motion-error]');
        const weights = [...this.querySelectorAll('[data-motion-weight]')];
        const root = this.closest('[data-kgp]');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        let inView = false;
        let userPaused = false;
        let playAttempt = 0;
        video.controls = false;
        video.muted = true;
        toggle.hidden = false;
        this.querySelector('.kgp-motion-weights').hidden = false;
        const sync = () => {
          label.textContent = video.paused ? label.dataset.play : label.dataset.pause;
          icon.textContent = video.paused ? '▶' : 'Ⅱ';
          const index = Math.min(3, Math.floor(video.currentTime / 2));
          weights.forEach((button, position) => {
            if (position === index) button.dataset.active = 'true';
            else delete button.dataset.active;
          });
        };
        const play = async () => {
          const attempt = ++playAttempt;
          error.hidden = true;
          if (video.error) video.load();
          try { await video.play(); }
          catch (reason) {
            if (attempt !== playAttempt || reason.name === 'AbortError') return;
            if (reason.name !== 'NotAllowedError') error.hidden = false;
            sync();
          }
        };
        const pause = () => { playAttempt++; video.pause(); sync(); };
        const automaticPlayback = () => {
          if (inView && !document.hidden && !reduced.matches && !userPaused) play();
          else pause();
        };
        toggle.addEventListener('click', () => {
          userPaused = !video.paused;
          if (userPaused) pause();
          else play();
        });
        video.addEventListener('timeupdate', sync);
        video.addEventListener('pause', sync);
        video.addEventListener('play', () => {
          sync();
          root?.querySelectorAll('video').forEach(other => { if (other !== video) other.pause(); });
          root?.querySelectorAll('[data-long-video] iframe').forEach(frame => {
            frame.contentWindow?.postMessage(JSON.stringify({event:'command', func:'pauseVideo', args:[]}), 'https://www.youtube-nocookie.com');
          });
        });
        video.addEventListener('error', () => { error.hidden = false; sync(); });
        this.resumeConnections = () => {
          this.controller = new AbortController();
          const options = {signal: this.controller.signal};
          root?.addEventListener('play', event => {
            if (event.target !== video && event.target.tagName === 'VIDEO') { userPaused = true; pause(); }
          }, {...options, capture: true});
          root?.addEventListener('click', event => {
            if (event.target.closest('[data-load-video]')) { userPaused = true; pause(); }
          }, options);
          document.addEventListener('visibilitychange', automaticPlayback, options);
          reduced.addEventListener('change', automaticPlayback, options);
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(entries => {
              inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.35;
              automaticPlayback();
            }, {threshold: [0, 0.35]});
            this.observer.observe(video);
          }
        };
        this.resumeConnections();
        sync();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        this.querySelector('video')?.pause();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
